<template>
	<section class="promo-banners">
		<div data-aos="fade-up" class="promo-banners__item-wrap">
			<NuxtLink to="https://carfree.webflow.io/" target="_blank">
				<article class="promo-banners__item">
					<div>
						<div class="promo-banners__item-badge promo-banners__item-badge--white"><GlobalIcon name="apple-logo" :width="18" /></div>
						<div class="promo-banners__item-badge promo-banners__item-badge--white"><GlobalIcon name="google-play" :width="18" /></div>
					</div>
					<h3 class="promo-banners__item-title">
						{{ $t('modules.loyalty_program_module.loyalty_program_promo_banners.book_with_the_app') }}<br />{{
							$t('modules.loyalty_program_module.loyalty_program_promo_banners.and')
						}}
						<span>{{ $t('modules.loyalty_program_module.loyalty_program_promo_banners.collect_points') }}</span>
					</h3>
					<GlobalImage
						class="promo-banners__item-image promo-banners__item-image--phone"
						src="loyalty-promo-banner-phone.png"
						alt="Loyalty promo banner phone"
						:width="1016" />
					<GlobalImage
						class="promo-banners__item-image-mobile promo-banners__item-image-mobile--phone"
						src="loyalty-promo-banner-phone-mobile.png"
						alt="Loyalty promo banner phone mobile"
						:width="518" />
				</article>
			</NuxtLink>
		</div>
		<div data-aos="fade-up" class="promo-banners__item-wrap">
			<article class="promo-banners__item">
				<div class="promo-banners__item-badge"><GlobalIcon name="star-empty-color" :width="24" /></div>
				<h3 class="promo-banners__item-title">
					{{ $t('modules.loyalty_program_module.loyalty_program_promo_banners.exchange_for_rewards') }}<br />{{
						$t('modules.loyalty_program_module.loyalty_program_promo_banners.rewards_and_discounts')
					}}
					<span>{{ $t('modules.loyalty_program_module.loyalty_program_promo_banners.discounts') }}</span>
				</h3>
				<GlobalImage
					class="promo-banners__item-image promo-banners__item-image--reward"
					:src="`loyalty-promo-banner-reward-${locale}.png`"
					alt="Loyalty promo banner reward"
					:width="438" />

				<GlobalImage
					class="promo-banners__item-image promo-banners__item-image--reward2"
					:src="`loyalty-promo-banner-reward2-${locale}.png`"
					alt="Loyalty promo banner reward2"
					:width="438" />
				<GlobalImage
					class="promo-banners__item-image-mobile promo-banners__item-image-mobile--reward"
					:src="`loyalty-promo-banner-reward-${locale}.png`"
					alt="Loyalty promo banner reward mobile"
					:width="306" />
			</article>
		</div>
	</section>
</template>

<script setup lang="ts">
const { locale } = useI18n()
</script>

<style scoped lang="scss">
@import './LoyaltyProgramPromoBanners.scss';
</style>
